import { render } from "./page-recommend.vue?vue&type=template&id=30871706&scoped=true"
import script from "./page-recommend.vue?vue&type=script&lang=js"
export * from "./page-recommend.vue?vue&type=script&lang=js"

import "./page-recommend.vue?vue&type=style&index=0&id=30871706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30871706"]])

export default __exports__